import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { requireLoggedIn, requireLogout, requireSuperadmin } from './services/auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'game-tracker/past-games',
    // redirectTo: 'configuration/manage-teams',
    // redirectTo: 'game-tracker/test',
    // redirectTo: 'game-tracker/connection',
    // redirectTo: 'game-tracker/track',
    // redirectTo: 'login',
    // redirectTo: 'optin',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
    canActivate: [requireLogout]
  },
  {
    path: 'payment-confirmation',
    loadComponent: () => import('./pages/payment-confirmation/payment-confirmation.page').then(m => m.PaymentConfirmationPage)
  },
  {
    path: 'optin',
    loadChildren: () => import('./pages/optin-module/optin-module.module').then(m => m.OptinModule),
    canActivate: [requireLoggedIn]
  },
  {
    path: 'game-tracker',
    loadChildren: () => import('./pages/game-tracker-module/game-tracker.module').then(m => m.GameTrackerModule),
    canActivate: []
  },
  {
    path: 'configuration',
    loadChildren: () => import('./pages/configuration-module/configuration-module.module').then(m => m.ConfigurationModule),
    canActivate: [requireLoggedIn]
  },
  {
    path: 'superadmin',
    loadChildren: () => import('./pages/superadmin-module/superadmin.module').then(m => m.SuperadminModule),
    canActivate: [requireSuperadmin]
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule),
    canActivate: [requireLoggedIn]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
